import { render, staticRenderFns } from "./WebBadgeComponent.vue?vue&type=template&id=5b116cef&scoped=true&"
import script from "./WebBadgeComponent.vue?vue&type=script&lang=js&"
export * from "./WebBadgeComponent.vue?vue&type=script&lang=js&"
import style0 from "./WebBadgeComponent.vue?vue&type=style&index=0&id=5b116cef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b116cef",
  null
  
)

export default component.exports